// extracted by mini-css-extract-plugin
export default {"controlsView":"CategorySelectModal_controlsView__KIEto"};